import Tab from "./Tab.js";
export default Tab;
